const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const deleteLeadSpecificDepositMethodApi = async (leadId, leadMethodId) => {
    const token = localStorage.getItem('token');
    const url = `${API_BASE_URL}/admin/lead/leads/${leadId}/deposit-methods/${leadMethodId}`;

    if (!token) {
        throw new Error('Токен авторизации не найден.');
    }

    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData?.message || `Ошибка ${response.status}: не удалось удалить метод депозита лида.`);
        }

        return response.status;
    } catch (error) {
        throw error;
    }
};
